<template>
  <div
    id="menu-global-search"
    :class="`global-search ${isFocus ? 'global-search-focus' : ''} ${
      isSubscriptionsInvalid || !orgPlanDetails?.planId ? 'disabled' : ''
    }`"
    @keyup.esc="$emit('close-menu')"
    @keyup.enter="
      () => {
        isTyping = false;
        $emit('on-search');
      }
    "
  >
    <img v-if="isFocus" src="/img/search_icon.svg" alt="search_icon" />
    <SearchIcon
      v-else
      :color="`#ffffff`"
      :class="`tw-w-[12px] tw-h-[12px] icon-pointer-unset`"
    />
    <input
      ref="inputRef"
      type="text"
      :value="searchKey"
      :placeholder="`${getComponentUiText('app-header-search-prompt-1')}`"
      @input="
        (e: any) => {
          isTyping = true;
          $emit('change-search-key', e?.target.value);
          onInput();
        }
      "
      @focus="onFocus"
      @focusout="isTyping = false"
    />
    <button v-show="!!searchKey" @click="onClear">
      <img src="/img/close_icon_white.svg" alt="close_icon" />
    </button>
    <span v-show="isFocus" @click="onSearch">
      {{ getComponentUiText("app-header-search-button-search-label-1") }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, Ref, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import EventEmitter from "@/utils/eventEmitter";
import SearchIcon from "@/components/svgs/searchIcon.vue";
import { IPlanDetails } from "@/interfaces/org/subscription";
import store from "@/store";
const props = defineProps<{
  isFocus: boolean;
  searchKey: string;
}>();

const emit = defineEmits<{
  (e: "focus"): void;
  (e: "close-menu"): void;
  (e: "change-search-key", value: string): void;
  (e: "on-search"): void;
}>();

const inputRef = ref<HTMLInputElement | null>(null);
const isTyping = ref(false);
let timeoutId: any | number | null = null;
const isSubscriptionsInvalid = ref(false);
const orgPlanDetails: Ref<IPlanDetails> = computed(
  () => store.getters["Org/getPlanDetails"],
);

watch(
  () => props.isFocus,
  () => {
    if (props.isFocus) {
      inputRef.value?.focus();
    } else {
      inputRef.value?.blur();
    }
  },
);

watch(
  () => orgPlanDetails.value,
  () => {
    if (!orgPlanDetails.value || !orgPlanDetails.value.planId) {
      isSubscriptionsInvalid.value = true;
    } else {
      isSubscriptionsInvalid.value = false;
    }
  },
);

onMounted(() => {
  setTimeout(() => {
    const cond = document.getElementById("pricing-table-container");
    if (cond) {
      isSubscriptionsInvalid.value = true;
    } else {
      isSubscriptionsInvalid.value = false;
    }
  }, 1000);
  if (props.isFocus) {
    inputRef.value?.focus();
  }
});

const onInput = () => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
  timeoutId = setTimeout(() => {
    if (isTyping.value) {
      emit("on-search");
    }
  }, 750);
};

const onClear = () => {
  isTyping.value = false;
  emit("change-search-key", "");
  inputRef.value?.focus();
};

const onSearch = () => {
  isTyping.value = false;
  emit("on-search");
  inputRef.value?.focus();
};

const onFocus = () => {
  emit("focus");
  EventEmitter.emit("active-org-dropDown-close-dropdown");
};
</script>

<style lang="scss" scoped>
.global-search-focus {
  width: 100% !important;
  background-color: #ffffff !important;
  & > input {
    color: #211f58 !important;
    &::placeholder {
      color: #211f58 !important;
    }
  }
}
.disabled {
  pointer-events: none;
}
.icon-pointer-unset {
  cursor: unset !important;
}
.global-search {
  display: flex;
  float: right;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background-color: #fff;
  padding: 12px;
  border-radius: 6px;
  height: 36px;
  gap: 7px;
  transition: width 0.3s;
  width: 193px;
  background-color: #0345bd;

  &:focus-within {
    width: 100%;
  }

  & > img {
    width: 12px;
    height: 12px;
    font-weight: 500;
    filter: grayscale(100%);
  }
  & > input {
    background: transparent;
    border: none;
    border-radius: 5px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    outline: none;
    width: 100%;
    &::placeholder {
      color: #ffffff;
    }
  }
  & > span {
    font-family: Inter, sans-serif;
    font-size: 10px;
    font-weight: 700;
    color: #387dff;
    text-transform: uppercase;
    float: right;
    letter-spacing: 1.5px;
    cursor: pointer;
    user-select: none;
  }

  & > button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 14px;
    height: 14px;
    background-color: #dbdbdb;
    border-radius: 50%;
    padding: 6px;
    margin: 6px;
    cursor: pointer;
    & > img {
      width: 6px;
      height: 6px;
    }
  }
}
</style>
